/*
 * @Author: Kuiper
 * @Date: 2021-06-12 10:03:34
 * @LastEditTime: 2021-08-13 18:17:47
 */
import { createStore, createLogger, Store } from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import mutations from './mutations'
import modules from './modules'
import { StateType } from './types'
import { App, InjectionKey } from 'vue'

export const key: InjectionKey<Store<StateType>> = Symbol()

const store: Store<StateType> = createStore({
  strict: true,
  mutations,
  modules: { ...modules },
  plugins:
    process.env.NODE_ENV !== 'production'
      ? [
          createLogger(),
          createPersistedState({
            key: '__CC_SHARE_USER__',
            paths: ['user'],
            // reducer(val) {
            //   return val.user.userInfo
            // }
          }),
        ]
      : [
          createPersistedState({
            key: '__CC_SHARE_USER__',
            paths: ['user'],
            // reducer(val) {
            //   return val.user.userInfo
            // }
          }),
        ],
})

export function setupStore(app: App<Element>) {
  app.use(store)
}

export { store }
